import { render, staticRenderFns } from "./WsMainExpertCard.vue?vue&type=template&id=338da964&scoped=true"
import script from "./WsMainExpertCard.vue?vue&type=script&lang=js"
export * from "./WsMainExpertCard.vue?vue&type=script&lang=js"
import style0 from "./WsMainExpertCard.vue?vue&type=style&index=0&id=338da964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338da964",
  null
  
)

export default component.exports